import { deepFreeze } from '../../utils/misc_utils';

export const PopSuccessMessageEnum = deepFreeze({});

export const PopErrorMessageEnum = deepFreeze({
    GET_POP: 'Pobranie popa nie powiodło się',
    GET_POPS: 'Pobranie popów nie powiodło się',
    GET_HUB: 'Pobranie huba nie powiodło się',
    GET_HUBS: 'Pobranie hubów nie powiodło się',
});

const PopServerErrorMessageEnum = deepFreeze({});

export const getPopErrorMessage = (message, defaultErrorMessage) => {
    for (let key in PopServerErrorMessageEnum) {
        if (PopServerErrorMessageEnum.hasOwnProperty(key)) {
            if (message?.substring(0, message?.indexOf(' ')) === PopServerErrorMessageEnum[key].errorCode) {
                return PopServerErrorMessageEnum[key].message;
            }
        }
    }

    return defaultErrorMessage;
};
